import domWrap from "../utils/domWrap";
import h from "../utils/htm";

export default async resources => { // comp-resources
	if (resources.hasAttribute('page')) {
		const parentGroups = getParentGroups(resources),
			form = domWrap(h('form filters',
				h('select name="category"',
					h('option value=""', 'All') +
					parentGroups
						.map((item, index) => h(`option value="${item.value}"`, item.value))
						.join('')
				)
					('div resources filters',
						h('div class="label"', 'Filters: ')
							('div class="filter selected" data-filter="Videos"', 'Videos')
							('div class="filter selected" data-filter="Images"', 'Images')
							('div class="filter selected" data-filter="Brochures and Spec Sheets"', 'Brochures & Specs')
					)
			).Node),
			filters = [...form.querySelectorAll('[resources][filters] .filter')],
			resourcesHTML = resources.innerHTML,
			groupTypes = ['Images', 'Videos', 'Brochures and Spec Sheets'];
		resources.before(form);

		form.on('change', '[filters] select', updateView)
			.on('click', '[resources][filters] .filter', function () {
				this.classList.toggle('selected');
				updateView();
			});

		function getParentGroups(resources) {
			return [...resources.querySelectorAll(':scope > [group]')]
				.map(x => { return { value: x.getAttribute('group'), element: x } });
			return arr;
		}

		function buildGroup(dom, source, filterKeys) {

			const groupName = source.getAttribute('group');

			if (groupName && filterKeys.find(x => x === groupName) !== undefined) {
				dom.appendChild(source);
				return true;
			}

			const copy = source.cloneNode(false);

			const titles = [...source.querySelectorAll(':scope > h3, :scope > [assets]')];
			titles.forEach(x => copy.appendChild(x));

			const queryGroups = [...source.querySelectorAll(':scope > [group]')];

			let hasFilter = false;
			for (const x in queryGroups)
				hasFilter = buildGroup(copy, queryGroups[x], filterKeys) || hasFilter;

			if (hasFilter)
				dom.appendChild(copy);

			return hasFilter;
		}

		function updateView() {
			const indexKey = form.querySelector('[filters] select').value
			const filterKeys = filters.filter(x => x.classList.contains('selected'))
				.map(x => x.getAttribute('data-filter'));
			const filterQuery = filterKeys
				.map((item) => `[group="${item}"]`)
				.toString();
			const groups = indexKey === '' ? parentGroups : parentGroups.filter(x => x.value === indexKey);
			const filtered = groups
				.reduce((accumulator, currentValue, currentIndex) => {
					const div = document.createElement('div');
					buildGroup(div, currentValue.element.cloneNode(true), filterKeys);
					const group = div.innerHTML;
					return [...accumulator, group];
				}, []);


			resources.innerHTML = filtered.join('');

		}
	}
	else {
		// Resource Component
		domWrap(resources).on('click', '[group] > h3', function () {
			const group = domWrap(this.closest('[group]'));
			group.setSelected('open');
			document.body.scroll({
				top: this.offsetTop - prevAll(group).reduce((prev, item) => item.classList.contains('open') ? prev + item.offsetHeight : prev, 0),
				behavior: 'smooth'
			});

		});
		domWrap(resources.querySelector('[group]')).setSelected('open');
	}

	function prevAll(element) {
		const result = [];
		while (element = element.previousElementSibling)
			result.push(element);
		return result;
	}
};
